import PropTypes from "prop-types";
import { memo, useCallback } from "react";
import SmartDPMarketingHeadline from "app/pages/SmartDP/SmartDPMarketingHeadline/SmartDPMarketingHeadline";
import SmartDPHeroCommercialTag from "app/pages/SmartDP/SmartDPHeroCommercialTag/SmartDPHeroCommercialTag";
import ChevronRight from "app/pages/.shared/static/icons/ChevronRight";
import { FormattedMessage } from "react-intl";
import { stringify } from "qs";
import { isAbsoluteUrl } from "app/utils/urlDataExtractor";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import Button, { BUTTON_ICON_ALIGNMENTS, BUTTON_VARIANTS } from "app/pages/.shared/form/Button";

const SmartDPHeroCommercialContent = ({ heroCommercialMerch = {} }) => {
	const { track } = useAnalytics();
	const navigate = useNavigate();
	const title =
		heroCommercialMerch?.displayOptions?.heroCommercial?.merchandisingTitle ||
		heroCommercialMerch?.displayOptions?.smartDP?.merchandisingTitle;
	const subtitle =
		heroCommercialMerch?.displayOptions?.heroCommercial?.merchandisingSubtitle ||
		heroCommercialMerch?.displayOptions?.smartDP?.merchandisingSubtitle;
	const showCta = heroCommercialMerch?.displayOptions?.heroCommercial?.showCta;
	const labelCta = heroCommercialMerch?.displayOptions?.heroCommercial?.labelCta || (
		<FormattedMessage id="landingPage.footer.redirect.cta.text" />
	);
	const heroTextAlign =
		heroCommercialMerch?.displayOptions?.heroCommercial?.heroTextAlign ||
		heroCommercialMerch?.displayOptions?.heroTextAlign ||
		"center";
	const tag = heroCommercialMerch?.displayOptions?.heroCommercial?.tag || undefined;
	const redirectionUrl = heroCommercialMerch?.displayOptions?.heroCommercial?.url || undefined;
	const merchandisingCode = heroCommercialMerch?.code;

	const handleCtaClicked = useCallback(() => {
		track("click_hero");
		if (redirectionUrl) {
			if (isAbsoluteUrl(redirectionUrl)) {
				window.location = redirectionUrl;
			} else {
				navigate({ pathname: `/${redirectionUrl}` });
			}
		} else {
			navigate({ pathname: "/merch", search: `?${stringify({ code: merchandisingCode })}` });
		}
	}, [merchandisingCode, redirectionUrl]);

	const lowestPrice = heroCommercialMerch?.lowestPrice;
	const homePageLogo = heroCommercialMerch?.displayOptions?.heroCommercial?.logoHomepage;
	return (
		<>
			<div
				className="smartDP-hero-commercial__image-headline"
				data-testid="smartDP-hero-commercial-image-headline"
			>
				{tag && <SmartDPHeroCommercialTag tag={tag?.toUpperCase()} />}

				{homePageLogo && (
					<img
						src={homePageLogo}
						alt=""
						className="smartDP-hero-commercial__logo-homepage"
						onClick={handleCtaClicked}
					/>
				)}

				<SmartDPMarketingHeadline
					title={title}
					subtitle={subtitle}
					textAlign={heroTextAlign}
					lowestPrice={lowestPrice}
					hideSubtitle={Boolean(homePageLogo)}
					onClick={handleCtaClicked}
				/>

				{showCta && (
					<Button
						variant={BUTTON_VARIANTS.STROKE}
						className="smartDP-hero-commercial__redirect--button"
						data-testid="smartDP-hero-commercial-redirect-button"
						label={labelCta}
						onClick={handleCtaClicked}
						alignIcon={BUTTON_ICON_ALIGNMENTS.RIGHT}
						icon={<ChevronRight />}
					/>
				)}
			</div>
		</>
	);
};
SmartDPHeroCommercialContent.propTypes = {
	heroCommercialMerch: PropTypes.object,
};
export default memo(SmartDPHeroCommercialContent);
